"use strict";

function init() {
    let getCookie = shvenergy.cookies.getCookie("_shvenergy_resume_wizard_tool");
    let confirmButton = document.querySelector(".confirm-button");
    let quoteCloseButton = document.querySelector(".quote-close-button");

    if (confirmButton) {
        confirmButton.addEventListener('click', closeAndEraseCookie);
    }

    if (quoteCloseButton) {
        quoteCloseButton.addEventListener('click', closePopUp);

        if (shvenergy.cookies.hasCookieCategoryConsent("_shvenergy_resume_wizard_tool") && getCookie) {
            document.querySelector(".quote-box").style.display = "block";
        } else {
            document.querySelector(".quote-box").remove();
        }
    }

    function closePopUp() {
        document.querySelector(".quote-box").remove();
    }

    function createCookie(name, value, hours) {
        let date = new Date();
        date.setTime(hours);
        let expires = `; expires=${date.toGMTString()}`;

        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function closeAndEraseCookie() {
        closePopUp();
        eraseCookie('_shvenergy_resume_wizard_tool');
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }
}

init();